// One representative GMB-style photo per demo business for the review module.
const DEMO_IMAGE_POOL = [
  'https://images.unsplash.com/photo-1621451537820-6244679853d5?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80',
];

const EXAMPLE_JUNK_REMOVAL_NASHVILLE = [
  {
    name: "Junk King Nashville",
    address: "2210 Clifton Ave, Nashville, TN 37209",
    latitude: 36.1580,
    longitude: -86.8210,
    maps_uri: "https://maps.google.com/?cid=junkking-nash",
    rating_count: 487,
    rating_avg: 4.8,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 3200 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 9, "2025-05": 11, "2025-06": 8, "2025-07": 26,
        "2025-08": 24, "2025-09": 22, "2025-10": 13, "2025-11": 15,
        "2025-12": 5, "2026-01": 31, "2026-02": 28, "2026-03": 17,
      },
      sentimentBreakdown: { positive: 420, neutral: 45, negative: 22 },
    },
    insight: "## Competitive Advantages\n* **Dominant brand recognition** in the Nashville metro with franchise-level marketing spend and consistent 5-star service delivery.\n* **Same-day service availability** gives them an edge over competitors who require 48-hour scheduling.\n## Quick Wins\n* **Limited evening availability** — competitors offering after-6pm pickups could capture their overflow.\n* **No transparent pricing online** — showing upfront estimates could win price-conscious customers.",
  },
  {
    name: "Nashville Junk Removal Pros",
    address: "1414 4th Ave S, Nashville, TN 37210",
    latitude: 36.1475,
    longitude: -86.7715,
    maps_uri: "https://maps.google.com/?cid=nashjunkpros",
    rating_count: 312,
    rating_avg: 4.9,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 1800 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 8, "2025-05": 11, "2025-06": 14, "2025-07": 10,
        "2025-08": 16, "2025-09": 13, "2025-10": 18, "2025-11": 15,
        "2025-12": 9, "2026-01": 12, "2026-02": 17, "2026-03": 10,
      },
      sentimentBreakdown: { positive: 285, neutral: 20, negative: 7 },
    },
    insight: "## Competitive Advantages\n* **Highest-rated in the market** at 4.9 stars — customer experience is a clear differentiator.\n* **Strong Google Maps visibility** driving organic leads without heavy ad spend.\n## Quick Wins\n* **No commercial service offerings** — expanding to business clients could double revenue.\n* **Website lacks SEO content** — blog posts about junk removal tips would boost organic traffic.",
  },
  {
    name: "1-800-GOT-JUNK Nashville",
    address: "3401 Dickerson Pike, Nashville, TN 37207",
    latitude: 36.2150,
    longitude: -86.7580,
    maps_uri: "https://maps.google.com/?cid=gotjunk-nash",
    rating_count: 623,
    rating_avg: 4.5,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 8500 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 18, "2025-05": 22, "2025-06": 25, "2025-07": 20,
        "2025-08": 28, "2025-09": 24, "2025-10": 30, "2025-11": 26,
        "2025-12": 15, "2026-01": 23, "2026-02": 27, "2026-03": 19,
      },
      sentimentBreakdown: { positive: 498, neutral: 80, negative: 45 },
    },
    insight: "## Competitive Advantages\n* **National brand awareness** drives massive organic search volume and trust.\n* **Highest review volume** in the Nashville market with consistent monthly growth.\n## Quick Wins\n* **Lower rating average (4.5)** compared to local competitors — response time complaints are a recurring theme.\n* **Premium pricing** creates opportunity for value-focused competitors to capture budget-conscious customers.",
  },
  {
    name: "Hoss Junk Removal",
    address: "110 28th Ave N, Nashville, TN 37203",
    latitude: 36.1660,
    longitude: -86.8050,
    maps_uri: "https://maps.google.com/?cid=hossjunk-nash",
    rating_count: 189,
    rating_avg: 4.7,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 950 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 5, "2025-05": 7, "2025-06": 9, "2025-07": 6,
        "2025-08": 11, "2025-09": 8, "2025-10": 12, "2025-11": 10,
        "2025-12": 4, "2026-01": 8, "2026-02": 13, "2026-03": 7,
      },
      sentimentBreakdown: { positive: 165, neutral: 18, negative: 6 },
    },
    insight: "## Competitive Advantages\n* **Strong local reputation** in Midtown and West Nashville neighborhoods.\n* **Eco-friendly disposal** messaging resonates with environmentally conscious customers.\n## Quick Wins\n* **Slow review velocity** — needs a review generation strategy to keep pace with larger competitors.\n* **No Google Ads presence** — even a small PPC budget could capture high-intent searches.",
  },
  {
    name: "Two Men and a Truck Nashville",
    address: "555 Mainstream Dr, Nashville, TN 37228",
    latitude: 36.1890,
    longitude: -86.8120,
    maps_uri: "https://maps.google.com/?cid=twomen-nash",
    rating_count: 534,
    rating_avg: 4.6,
    primary_type: "moving_company",
    traffic_data: { metrics: { estimated_monthly_visitors: 5200 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 14, "2025-05": 17, "2025-06": 20, "2025-07": 16,
        "2025-08": 23, "2025-09": 19, "2025-10": 25, "2025-11": 21,
        "2025-12": 12, "2026-01": 18, "2026-02": 22, "2026-03": 15,
      },
      sentimentBreakdown: { positive: 440, neutral: 62, negative: 32 },
    },
    insight: "## Competitive Advantages\n* **Dual service offering** (moving + junk removal) captures customers during life transitions.\n* **Strong franchise marketing** and brand recognition across Nashville suburbs.\n## Quick Wins\n* **Junk removal is secondary** to moving — dedicated junk removal companies outrank them for those specific keywords.\n* **Higher pricing** for standalone junk removal compared to specialists.",
  },
  {
    name: "Stand Up Guys Junk Removal",
    address: "2300 21st Ave S, Nashville, TN 37212",
    latitude: 36.1330,
    longitude: -86.7950,
    maps_uri: "https://maps.google.com/?cid=standupguys-nash",
    rating_count: 267,
    rating_avg: 4.8,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 2100 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 7, "2025-05": 10, "2025-06": 12, "2025-07": 9,
        "2025-08": 14, "2025-09": 11, "2025-10": 16, "2025-11": 13,
        "2025-12": 6, "2026-01": 10, "2026-02": 15, "2026-03": 8,
      },
      sentimentBreakdown: { positive: 238, neutral: 22, negative: 7 },
    },
    insight: "## Competitive Advantages\n* **Excellent brand name** — memorable and trustworthy positioning.\n* **Strong review quality** with detailed, authentic customer stories.\n## Quick Wins\n* **Limited service area** — expanding to Murfreesboro/Franklin would open new revenue.\n* **Website loading speed is slow** — page speed improvements would boost SEO rankings.",
  },
  {
    name: "Rapid Removal Nashville",
    address: "4825 Trousdale Dr, Nashville, TN 37220",
    latitude: 36.0870,
    longitude: -86.7640,
    maps_uri: "https://maps.google.com/?cid=rapidremoval-nash",
    rating_count: 156,
    rating_avg: 4.6,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 680 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 4, "2025-05": 6, "2025-06": 8, "2025-07": 5,
        "2025-08": 9, "2025-09": 7, "2025-10": 10, "2025-11": 8,
        "2025-12": 3, "2026-01": 6, "2026-02": 11, "2026-03": 5,
      },
      sentimentBreakdown: { positive: 130, neutral: 18, negative: 8 },
    },
    insight: "## Competitive Advantages\n* **Fast response times** — same-day service is their core selling point.\n* **Competitive pricing** undercuts franchise competitors by 15-20%.\n## Quick Wins\n* **Low review count** relative to market — aggressive review generation could shift rankings.\n* **No social media presence** — Instagram before/after posts could drive referrals.",
  },
  {
    name: "Brentwood Junk Haulers",
    address: "330 Franklin Rd, Brentwood, TN 37027",
    latitude: 36.0331,
    longitude: -86.7828,
    maps_uri: "https://maps.google.com/?cid=brentwood-junk",
    rating_count: 98,
    rating_avg: 4.9,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 420 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 2, "2025-05": 3, "2025-06": 5, "2025-07": 3,
        "2025-08": 6, "2025-09": 4, "2025-10": 7, "2025-11": 5,
        "2025-12": 2, "2026-01": 4, "2026-02": 6, "2026-03": 3,
      },
      sentimentBreakdown: { positive: 92, neutral: 5, negative: 1 },
    },
    insight: "## Competitive Advantages\n* **Highest per-review quality** in the market — nearly perfect 4.9 rating.\n* **Premium Brentwood positioning** attracts high-value residential clients.\n## Quick Wins\n* **Very low review volume** — growth is stalling without more reviews.\n* **No commercial services** — Brentwood office parks are an untapped market.",
  },
  {
    name: "College Hunks Hauling Junk Nashville",
    address: "1033 Demonbreun St, Nashville, TN 37203",
    latitude: 36.1540,
    longitude: -86.7870,
    maps_uri: "https://maps.google.com/?cid=collegehunks-nash",
    rating_count: 445,
    rating_avg: 4.4,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 6100 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 12, "2025-05": 15, "2025-06": 19, "2025-07": 14,
        "2025-08": 21, "2025-09": 17, "2025-10": 23, "2025-11": 20,
        "2025-12": 10, "2026-01": 16, "2026-02": 20, "2026-03": 12,
      },
      sentimentBreakdown: { positive: 345, neutral: 65, negative: 35 },
    },
    insight: "## Competitive Advantages\n* **Strong national franchise brand** with excellent marketing support.\n* **Moving + junk removal combo** captures customers at key life moments.\n## Quick Wins\n* **Rating has dropped to 4.4** — negative reviews cite scheduling issues and no-shows.\n* **High ad spend** but low organic ranking — SEO investment would reduce customer acquisition cost.",
  },
  {
    name: "Lightning Junk Removal",
    address: "700 Main St, Hendersonville, TN 37075",
    latitude: 36.3048,
    longitude: -86.6201,
    maps_uri: "https://maps.google.com/?cid=lightning-junk",
    rating_count: 134,
    rating_avg: 4.7,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 540 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 3, "2025-05": 5, "2025-06": 7, "2025-07": 4,
        "2025-08": 8, "2025-09": 6, "2025-10": 9, "2025-11": 7,
        "2025-12": 2, "2026-01": 5, "2026-02": 8, "2026-03": 4,
      },
      sentimentBreakdown: { positive: 118, neutral: 12, negative: 4 },
    },
    insight: "## Competitive Advantages\n* **Dominates Hendersonville/Sumner County** — low competition in suburban market.\n* **Owner-operated personal touch** gets glowing reviews.\n## Quick Wins\n* **No presence in Nashville proper** — missing the largest customer base in the metro.\n* **Website is outdated** — modern redesign could improve conversion rates significantly.",
  },
  {
    name: "Middle TN Junk Removal",
    address: "201 E Main St, Murfreesboro, TN 37130",
    latitude: 35.8456,
    longitude: -86.3903,
    maps_uri: "https://maps.google.com/?cid=middletn-junk",
    rating_count: 203,
    rating_avg: 4.5,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 780 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 5, "2025-05": 7, "2025-06": 9, "2025-07": 6,
        "2025-08": 11, "2025-09": 8, "2025-10": 13, "2025-11": 10,
        "2025-12": 4, "2026-01": 7, "2026-02": 12, "2026-03": 6,
      },
      sentimentBreakdown: { positive: 170, neutral: 24, negative: 9 },
    },
    insight: "## Competitive Advantages\n* **Broad service area** covering Murfreesboro, Smyrna, and La Vergne.\n* **Strong commercial contracts** with property management companies.\n## Quick Wins\n* **Rating trending down** from 4.7 to 4.5 over 6 months — service quality needs attention.\n* **Competitors are gaining ground** in Murfreesboro with faster response times.",
  },
  {
    name: "Clutter Free Nashville",
    address: "2804 Opryland Dr, Nashville, TN 37214",
    latitude: 36.1930,
    longitude: -86.6940,
    maps_uri: "https://maps.google.com/?cid=clutterfree-nash",
    rating_count: 178,
    rating_avg: 4.8,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 1100 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 4, "2025-05": 6, "2025-06": 9, "2025-07": 5,
        "2025-08": 10, "2025-09": 7, "2025-10": 12, "2025-11": 9,
        "2025-12": 3, "2026-01": 7, "2026-02": 11, "2026-03": 5,
      },
      sentimentBreakdown: { positive: 160, neutral: 14, negative: 4 },
    },
    insight: "## Competitive Advantages\n* **Excellent customer communication** — reviews consistently praise responsiveness.\n* **Eco-friendly recycling focus** appeals to Nashville's growing green consumer base.\n## Quick Wins\n* **Limited marketing spend** — Google Ads for 'junk removal near me' would capture immediate leads.\n* **No referral program** — word-of-mouth is strong but could be amplified with incentives.",
  },
  {
    name: "Junk Docs Nashville",
    address: "122 Rosa Parks Blvd, Nashville, TN 37203",
    latitude: 36.1690,
    longitude: -86.7880,
    maps_uri: "https://maps.google.com/?cid=junkdocs-nash",
    rating_count: 89,
    rating_avg: 4.3,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 310 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 2, "2025-05": 3, "2025-06": 4, "2025-07": 2,
        "2025-08": 5, "2025-09": 3, "2025-10": 6, "2025-11": 4,
        "2025-12": 1, "2026-01": 3, "2026-02": 5, "2026-03": 2,
      },
      sentimentBreakdown: { positive: 68, neutral: 14, negative: 7 },
    },
    insight: "## Competitive Advantages\n* **Downtown Nashville location** gives easy access to the densest customer area.\n* **Hoarding cleanup specialty** fills a niche most competitors avoid.\n## Quick Wins\n* **Rating below market average at 4.3** — recent negative reviews about punctuality need addressing.\n* **Very low review velocity** — needs systematic review collection strategy.",
  },
  {
    name: "Franklin Junk Solutions",
    address: "203 Public Sq, Franklin, TN 37064",
    latitude: 35.9251,
    longitude: -86.8689,
    maps_uri: "https://maps.google.com/?cid=franklin-junk",
    rating_count: 167,
    rating_avg: 4.7,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 890 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 4, "2025-05": 6, "2025-06": 8, "2025-07": 5,
        "2025-08": 9, "2025-09": 7, "2025-10": 11, "2025-11": 9,
        "2025-12": 3, "2026-01": 6, "2026-02": 10, "2026-03": 5,
      },
      sentimentBreakdown: { positive: 148, neutral: 14, negative: 5 },
    },
    insight: "## Competitive Advantages\n* **Williamson County focus** — owns the affluent Franklin/Brentwood corridor.\n* **Estate cleanout specialty** commands premium pricing in high-income areas.\n## Quick Wins\n* **No expansion into Nashville** — missing the largest volume market nearby.\n* **Website doesn't rank for 'Nashville junk removal'** — geo-targeted pages would expand reach.",
  },
  {
    name: "Volunteer Junk Haul",
    address: "4001 Gallatin Pike, Nashville, TN 37216",
    latitude: 36.2100,
    longitude: -86.7390,
    maps_uri: "https://maps.google.com/?cid=volunteer-junk",
    rating_count: 221,
    rating_avg: 4.6,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 1400 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 6, "2025-05": 8, "2025-06": 11, "2025-07": 7,
        "2025-08": 13, "2025-09": 10, "2025-10": 15, "2025-11": 12,
        "2025-12": 5, "2026-01": 9, "2026-02": 14, "2026-03": 7,
      },
      sentimentBreakdown: { positive: 188, neutral: 24, negative: 9 },
    },
    insight: "## Competitive Advantages\n* **Consistent review growth** — gaining 10+ reviews per month shows strong momentum.\n* **East Nashville stronghold** in a rapidly growing, high-demand neighborhood.\n## Quick Wins\n* **No same-day service** — adding this could capture urgent removal customers.\n* **Pricing not visible online** — transparency would improve conversion from website visits.",
  },
  {
    name: "Clean Sweep Junk Nashville",
    address: "7105 Moores Ln, Brentwood, TN 37027",
    latitude: 36.0180,
    longitude: -86.7620,
    maps_uri: "https://maps.google.com/?cid=cleansweep-nash",
    rating_count: 112,
    rating_avg: 4.4,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 350 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 2, "2025-05": 4, "2025-06": 5, "2025-07": 3,
        "2025-08": 6, "2025-09": 4, "2025-10": 7, "2025-11": 5,
        "2025-12": 2, "2026-01": 3, "2026-02": 6, "2026-03": 3,
      },
      sentimentBreakdown: { positive: 88, neutral: 16, negative: 8 },
    },
    insight: "## Competitive Advantages\n* **Affordable pricing** — consistently mentioned as cheaper than franchise competitors.\n* **Flexible scheduling** including weekends attracts busy homeowners.\n## Quick Wins\n* **Rating at 4.4 is below market leaders** — a few bad reviews are dragging the average down.\n* **Minimal online presence** — Google Business Profile optimization alone could boost visibility 30%.",
  },
  {
    name: "Hermitage Hauling Co",
    address: "4501 Andrew Jackson Pkwy, Hermitage, TN 37076",
    latitude: 36.1661,
    longitude: -86.6108,
    maps_uri: "https://maps.google.com/?cid=hermitage-haul",
    rating_count: 76,
    rating_avg: 4.8,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 280 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 1, "2025-05": 2, "2025-06": 4, "2025-07": 2,
        "2025-08": 5, "2025-09": 3, "2025-10": 5, "2025-11": 4,
        "2025-12": 1, "2026-01": 3, "2026-02": 4, "2026-03": 2,
      },
      sentimentBreakdown: { positive: 70, neutral: 5, negative: 1 },
    },
    insight: "## Competitive Advantages\n* **Near-perfect reviews** in the Hermitage/Mt. Juliet area.\n* **Personal service** — owner handles every job, building strong referral network.\n## Quick Wins\n* **Extremely low volume** — can't scale with owner-only model.\n* **No website** — all leads come from Google Maps, missing significant organic traffic.",
  },
  {
    name: "Music City Junk Removal",
    address: "1720 West End Ave, Nashville, TN 37203",
    latitude: 36.1530,
    longitude: -86.8070,
    maps_uri: "https://maps.google.com/?cid=musiccity-junk",
    rating_count: 345,
    rating_avg: 4.7,
    primary_type: "junk_removal_service",
    traffic_data: { metrics: { estimated_monthly_visitors: 2400 } },
    historicalData: {
      monthlyReviewCounts: {
        "2025-04": 9, "2025-05": 12, "2025-06": 15, "2025-07": 11,
        "2025-08": 17, "2025-09": 14, "2025-10": 19, "2025-11": 16,
        "2025-12": 8, "2026-01": 13, "2026-02": 18, "2026-03": 10,
      },
      sentimentBreakdown: { positive: 300, neutral: 32, negative: 13 },
    },
    insight: "## Competitive Advantages\n* **Strong Nashville branding** — 'Music City' name resonates with local customers.\n* **Fast-growing review count** with 15+ new reviews per month in peak season.\n## Quick Wins\n* **No presence in the suburbs** — missing Brentwood, Franklin, and Hendersonville markets.\n* **Competitors are outspending on Google Ads** — increasing PPC budget would defend market share.",
  },
];

const FAKE_AD_TEMPLATES = [
  {
    title: "Nashville Junk Removal - Same Day Pickup Available",
    body: "Book online in 60 seconds. Upfront pricing, no hidden fees. We haul everything — furniture, appliances, yard waste & more. Trusted by 5,000+ Nashville homeowners.",
    keywords: ["junk removal nashville", "junk hauling near me", "same day junk pickup"],
    position: 1,
    searchDateId: 20260301,
    url: null,
  },
  {
    title: "Cheapest Junk Removal in Nashville | Free Estimates",
    body: "Why overpay? Get a free on-site estimate. We beat any competitor's price by 10%. Eco-friendly disposal. Licensed & insured. Call now for same-day service.",
    keywords: ["cheap junk removal", "affordable junk hauling nashville", "junk removal cost"],
    position: 2,
    searchDateId: 20260215,
    url: null,
  },
  {
    title: "Commercial Junk Removal Nashville | Office & Construction",
    body: "Serving Nashville businesses since 2015. Office cleanouts, construction debris, warehouse clearing. Volume discounts available. Schedule your free walkthrough today.",
    keywords: ["commercial junk removal", "office cleanout nashville", "construction debris removal"],
    position: 3,
    searchDateId: 20260228,
    url: null,
  },
];

const INTERNAL_SWOT_BY_BUSINESS = {
  "Junk King Nashville": `## Strengths
* **5-star reviews praise same-day scheduling** — crew consistently arrives within the quoted window, making the dispatch system a key internal asset
* **Customers highlight crew professionalism** — multiple reviews note that teams introduce themselves, wear uniforms, and explain pricing before starting work
* **"Left the area cleaner than before"** appears in 30+ reviews — post-job cleanup protocol is clearly well-trained and executed

## Weaknesses
* **1-star reviews cite surprise fees for heavy items** — internal pricing guide doesn't clearly communicate mattress/appliance surcharges upfront
* **Repeat complaints about phone hold times exceeding 10 minutes** — front desk staffing during peak hours (8-10am) is insufficient
* **Negative reviews mention crews rushing through jobs** — incentive structure may reward speed over thoroughness

## Opportunities
* Implement a **pre-job photo estimate tool** so customers can get accurate quotes via text before scheduling, reducing pricing disputes
* Create a **crew recognition program** tied to 5-star review mentions — top-reviewed teams get bonuses, reinforcing quality behaviors
* Develop **standardized heavy-item pricing cards** that crews hand to customers on-site to eliminate surprise fee complaints

## Threats
* Current crew training relies on ride-alongs only — if senior crew leads leave, **institutional knowledge of quality standards could erode quickly**
* Phone-based booking bottleneck risks losing customers to competitors with **instant online scheduling** — internal tech gap is widening
* Seasonal hiring of untrained temporary staff in summer creates **inconsistent service quality** that damages the brand built by full-time crews`,

  "Nashville Junk Removal Pros": `## Strengths
* **5-star reviews consistently mention "the owner showed up"** — hands-on ownership creates exceptional trust and accountability with every job
* **Customers praise transparent pricing with no hidden fees** — the walk-through estimate process before loading is a major internal differentiator
* **Reviews highlight careful handling of property** — crews are trained to use floor protectors and door bumpers, resulting in zero damage complaints

## Weaknesses
* **1-star reviews mention difficulty rescheduling** — the booking system doesn't allow easy date changes, forcing customers to call and wait
* **Complaints about limited availability on weekends** — only one crew runs Saturday shifts, creating long wait times during peak demand
* **Negative reviews cite lack of follow-up after service** — no post-job check-in process exists to catch issues before they become bad reviews

## Opportunities
* Add an **automated SMS confirmation and rescheduling system** to eliminate the most common customer frustration
* Implement a **post-job satisfaction text** sent 2 hours after completion — catch problems early and convert happy customers into reviewers
* Cross-train office staff on **basic dispatch tasks** so weekend capacity can flex without hiring additional full-time crews

## Threats
* Owner-dependent quality model means **scaling beyond 2 crews risks service inconsistency** if the owner can't personally oversee every job
* No documented SOPs for crew procedures — **tribal knowledge is the only training method**, creating vulnerability if key employees leave
* Lack of a CRM system means **repeat customer relationships aren't tracked**, missing easy upsell and re-engagement opportunities`,

  "1-800-GOT-JUNK Nashville": `## Strengths
* **5-star reviews highlight the branded, professional experience** — uniforms, clean trucks, and consistent greeting scripts make customers feel they're dealing with a premium operation
* **Customers love the upfront volume-based pricing model** — "point and it disappears" messaging in reviews shows the internal pricing system is intuitive
* **Reviews praise the booking experience** — online scheduling with 2-hour arrival windows is consistently called "easy and convenient"

## Weaknesses
* **1-star reviews repeatedly mention late arrivals and no-shows** — franchise dispatch system creates scheduling gaps when trucks run behind
* **Complaints about crews upselling to larger truck loads** — incentive structure may pressure crews to overestimate volume needed
* **Negative reviews cite corporate-style impersonal service** — scripts feel robotic to some customers who want a more personal interaction

## Opportunities
* Implement **real-time GPS tracking** shared with customers so they can see their truck's ETA instead of waiting blindly during the 2-hour window
* Redesign the **crew incentive model** to reward customer satisfaction scores rather than just load volume, reducing upselling complaints
* Add a **local Nashville touch** to the franchise scripts — let crews reference neighborhoods and local landmarks to feel less corporate

## Threats
* High crew turnover from franchise labor model means **constantly retraining new hires** — quality dips every time experienced crews leave
* Franchise fee structure limits ability to **offer competitive pricing** against lean local operators who undercut by 20-30%
* Corporate standardization prevents **adapting quickly to local Nashville market needs** — changes require franchise approval processes`,

  "Hoss Junk Removal": `## Strengths
* **5-star reviews rave about the personal touch** — the owner's direct involvement in every job creates a "neighbor helping neighbor" experience customers love
* **Customers highlight eco-friendly disposal** — reviews specifically mention that items are donated or recycled, showing internal sorting protocols resonate with buyers
* **"Above and beyond" appears frequently** — crews sweep the area, move remaining items back neatly, and offer to help with extra small tasks

## Weaknesses
* **1-star reviews cite slow response to initial inquiries** — sometimes 24-48 hours to get a quote back, which loses impatient customers
* **Complaints about limited truck capacity** — smaller trucks mean some large jobs require two trips, increasing cost and time
* **Negative reviews mention no clear cancellation policy** — customers who need to cancel feel uncertain about deposits and rebooking

## Opportunities
* Set up an **auto-reply system for quote requests** with estimated response time, so customers know their inquiry was received and when to expect a callback
* Invest in a **larger truck or trailer** for the second crew — eliminates double-trip complaints and increases per-job revenue
* Create a **clear written cancellation and rebooking policy** provided at time of booking to set expectations upfront

## Threats
* Owner handling every customer interaction creates a **single point of failure** — illness or vacation means the business stops
* Without formal crew training documentation, **new hires may not replicate the eco-friendly sorting process** that drives positive reviews
* Small team with no backup crews means **one truck breakdown halts all operations** — no redundancy in the current setup`,

  "Two Men and a Truck Nashville": `## Strengths
* **5-star reviews praise the two-service convenience** — customers booking both moving and junk removal in one call saves them time and builds loyalty
* **Crew strength and efficiency** highlighted in reviews — teams handle heavy furniture and appliance removal that smaller competitors can't match
* **Consistent positive mentions of pre-move junk removal bundles** — internal packaging of services into combos is a smart operational differentiator

## Weaknesses
* **1-star reviews say junk removal feels like an afterthought** — crews sometimes treat it as less important than moving jobs, rushing through removal tasks
* **Complaints about junk removal pricing being higher than specialists** — the general-purpose pricing model doesn't compete well against focused junk removal companies
* **Negative reviews mention confusion about which service was booked** — internal systems sometimes mix up moving vs. junk removal job types

## Opportunities
* Create a **dedicated junk removal crew** separate from moving teams — specialized training would improve service quality and reduce "afterthought" complaints
* Develop **junk removal-specific pricing tiers** that compete with local specialists instead of using the general moving rate structure
* Implement a **booking confirmation system** that clearly distinguishes between moving and junk removal jobs with separate checklists for each

## Threats
* Dual-service model creates **scheduling conflicts** where profitable moving jobs get priority and junk removal customers get pushed to less convenient time slots
* Crew morale for junk removal jobs may be lower than moving jobs — **perceived as less skilled work** could lead to quality issues
* Without separate brand positioning, **junk-removal-specific keywords in search get lost** behind the dominant moving brand identity`,

  "Stand Up Guys Junk Removal": `## Strengths
* **5-star reviews consistently mention trustworthiness** — the brand name delivers on its promise, with customers noting crews who are honest about what can be donated vs. trashed
* **Customers highlight detailed post-job photos** — crews take before/after photos and text them to customers, creating shareable content and accountability
* **Reviews praise the team's energy and attitude** — younger crews bring enthusiasm that older competitors lack, making the experience surprisingly enjoyable

## Weaknesses
* **1-star reviews cite website booking glitches** — the online scheduling tool sometimes double-books or doesn't confirm properly
* **Complaints about inconsistent crew sizes** — some customers get a 3-person team while others get 1 person for similar-sized jobs
* **Negative reviews mention difficulties reaching customer support** — no dedicated phone support person, calls go to voicemail during busy hours

## Opportunities
* Fix the **online booking system** with proper confirmation emails and SMS — this is the #1 source of negative reviews and is fully within internal control
* Standardize **minimum crew sizes by job estimate** — 2-person minimum for all jobs over a certain volume eliminates the understaffing complaints
* Hire or designate a **dedicated customer support person** during business hours to handle calls, freeing crews to focus on jobs

## Threats
* Reliance on younger, part-time crew members means **higher turnover risk** — quality could fluctuate with each new hire cycle
* The before/after photo practice isn't formally documented in SOPs — **if the culture shifts, this differentiator could silently disappear**
* Growing faster than internal systems can support — **more bookings without better scheduling tools will amplify existing tech problems**`,

  "Rapid Removal Nashville": `## Strengths
* **5-star reviews highlight blazing-fast response times** — "they showed up 2 hours after I called" is a common theme, showing excellent internal dispatch efficiency
* **Customers love the straightforward flat-rate pricing** — no complicated estimates, just a clear price based on truck space used
* **Reviews mention crews who are polite and respectful of property** — training on property protection is clearly working

## Weaknesses
* **1-star reviews mention rushed jobs leaving debris behind** — the speed-focused culture sometimes means corners get cut on final cleanup
* **Complaints about no itemized receipts** — customers want documentation of what was removed and where it went, especially for insurance claims
* **Negative reviews cite difficulty getting weekend appointments** — limited weekend availability frustrates customers who work weekdays

## Opportunities
* Add a **final walkthrough checklist** that crews complete with the customer before leaving — takes 2 minutes and eliminates "debris left behind" complaints
* Implement **digital receipts with itemized removal lists** — easy to generate from a phone app and adds professionalism that competitors lack
* Open **Saturday morning slots** by staggering crew schedules — even 4 hours of weekend availability would capture significant unmet demand

## Threats
* Speed-first culture without quality checks could lead to **escalating cleanup complaints** that erode the fast-service brand advantage
* No digital paper trail for jobs means **disputes are hard to resolve** — he-said-she-said situations damage reputation
* Flat-rate pricing without periodic market analysis risks **undercharging on large jobs** and eroding margins over time`,

  "Brentwood Junk Haulers": `## Strengths
* **5-star reviews praise white-glove service** — crews remove shoes indoors, use furniture pads on doorways, and treat high-end homes with appropriate care
* **Customers highlight the calm, unhurried approach** — unlike competitors, this team takes time to carefully sort and remove without making homeowners feel rushed
* **Reviews mention the owner's follow-up calls after jobs** — personal post-service check-ins create loyalty and catch issues before they become complaints

## Weaknesses
* **1-star reviews cite higher-than-expected pricing** — premium Brentwood positioning creates sticker shock for customers comparing to Nashville-rate competitors
* **Complaints about long wait times for scheduling** — only one crew means 7-10 day waits during busy periods
* **Negative reviews mention no online booking** — customers must call to schedule, which feels outdated for the affluent tech-savvy demographic they serve

## Opportunities
* Create a **transparent pricing page** on the website showing Brentwood-specific rates with clear justification for the premium (insurance, care protocols, etc.)
* Add a **second crew** to cut wait times in half — the demand clearly exists based on booking backlog
* Implement **online self-service booking** with instant confirmation — matches the expectations of the upscale customer base

## Threats
* Single-crew model means **one injury or illness cancels a full week of appointments** — no backup capacity exists
* Owner's personal follow-up calls don't scale — as the business grows, **this key differentiator becomes impossible to maintain** without delegation
* Premium pricing with long wait times creates a **vulnerability where customers try cheaper, faster competitors** while waiting for an appointment`,

  "College Hunks Hauling Junk Nashville": `## Strengths
* **5-star reviews praise the energetic, hardworking crews** — young teams tackle heavy lifting with enthusiasm that impresses customers
* **Customers highlight the dual moving/hauling convenience** — internal service bundling captures customers during high-need life moments
* **Reviews mention strong brand recognition** — customers feel confident choosing a national brand with local crews

## Weaknesses
* **1-star reviews cite scheduling no-shows and last-minute cancellations** — internal dispatch system has reliability gaps that frustrate customers
* **Complaints about crews being inexperienced with delicate items** — younger workforce needs more training on handling fragile belongings
* **Negative reviews mention aggressive upselling at the door** — crews quoting higher prices on-site than what was estimated over the phone

## Opportunities
* Implement a **mandatory confirmation call 1 hour before arrival** — eliminates no-show complaints and gives customers certainty
* Develop a **fragile item handling training module** for all new crew members — practice with mock scenarios before they handle real customer belongings
* Align **phone estimates with on-site quotes** by using photo-based pre-assessment — customers who feel bait-and-switched never come back

## Threats
* High crew turnover rate means **constantly rebuilding team chemistry and quality standards** — each new cohort needs the same training investment
* Franchise quality standards are set nationally but **local execution varies** — corporate audits can't catch day-to-day service gaps
* **Scheduling system failures are damaging the brand faster than marketing can repair it** — one no-show generates more word-of-mouth than ten good jobs`,

  "Lightning Junk Removal": `## Strengths
* **5-star reviews love the owner-operated personal experience** — customers feel like they're hiring a trusted neighbor, not a faceless company
* **Reviews praise honest pricing with no surprises** — the owner walks through the job, agrees on a price, and never changes it after loading
* **Customers highlight the small-town reliability** — appointments are always kept, and the owner calls ahead if running even 5 minutes late

## Weaknesses
* **1-star reviews mention limited capacity for large jobs** — estate cleanouts and construction debris exceed what the single-truck setup can handle in one trip
* **Complaints about no evening or weekend availability** — owner-only model means business hours only, missing customers who work 9-to-5
* **Negative reviews cite lack of a professional website** — customers feel uncertain booking a service with no online presence beyond Google Maps

## Opportunities
* Partner with a **local hauling company for overflow large jobs** rather than turning them away — keeps the customer and earns a referral fee
* Add **Saturday morning hours** (even just 8am-12pm) to capture weekend demand without overextending the work week
* Build a **simple one-page website** with services, pricing, and a booking form — cost is minimal and dramatically increases credibility

## Threats
* Owner-only operation is a **single point of failure** — any personal emergency means all appointments get canceled with no backup
* Without a website, **new customers who research online before calling will choose competitors** who look more established
* Hendersonville area is attracting new junk removal companies — **no-moat local reputation can be displaced** by a competitor with better marketing`,

  "Middle TN Junk Removal": `## Strengths
* **5-star reviews highlight the wide service area coverage** — customers in Murfreesboro, Smyrna, and La Vergne all report prompt service
* **Reviews praise the commercial job expertise** — property management companies specifically mention reliable recurring service
* **Customers note the organized crew coordination** — multi-person teams work efficiently without confusion, suggesting good internal job briefings

## Weaknesses
* **1-star reviews mention declining service quality** — recent complaints about careless handling and missed items suggest quality control is slipping
* **Complaints about difficulty reaching the office** — customers report calls going to voicemail with slow callbacks during peak periods
* **Negative reviews cite crews arriving without proper equipment** — some jobs required tools or truck capacity that wasn't pre-assessed

## Opportunities
* Implement **pre-job checklists** that dispatchers review with customers before sending crews — ensures the right equipment arrives for every job
* Add a **dedicated customer service phone line** with guaranteed callback times posted on voicemail — sets expectations and reduces frustration
* Create a **quality control audit system** where a manager spot-checks completed jobs weekly to catch the declining quality trend before it worsens

## Threats
* Declining rating from 4.7 to 4.5 signals **internal quality problems are accelerating** — without intervention, this trend could reach a tipping point
* Spread-thin service area means **crews spend significant time driving** instead of working jobs, reducing efficiency and increasing burnout
* Competitors in Murfreesboro are **responding faster and building reviews faster** — the regional advantage is eroding from all sides`,

  "Clutter Free Nashville": `## Strengths
* **5-star reviews consistently mention outstanding communication** — customers praise updates via text about arrival times, crew names, and job completion
* **Reviews highlight the eco-conscious disposal approach** — donation receipts and recycling documentation provided after every job impress environmentally-minded customers
* **Customers note the organized quoting process** — photo-based estimates with clear line items build trust before the crew even arrives

## Weaknesses
* **1-star reviews mention the quoting process taking too long** — while thorough, some customers wait 2-3 days for a formal estimate and book a faster competitor
* **Complaints about unanswered emails** — the team responds well to texts and calls but email inquiries sometimes fall through the cracks
* **Negative reviews cite limited same-day availability** — the thorough scheduling process means urgent requests often can't be accommodated

## Opportunities
* Create an **instant ballpark estimate tool** on the website — customers upload photos and get a range within minutes, with the detailed formal quote following later
* Set up **automated email auto-replies** acknowledging receipt and providing expected response time — prevents customers from feeling ignored
* Reserve **2 daily emergency slots** for same-day requests at a premium rate — captures urgent demand without disrupting the planned schedule

## Threats
* The thoroughness that drives 5-star reviews also creates **speed disadvantages** — customers with urgent needs will always choose a faster competitor
* Email communication gaps mean **some leads are simply lost** — each unanswered email is revenue walking to a competitor
* Over-reliance on the photo-estimate workflow creates **bottlenecks when the estimator is unavailable** — no backup person can generate quotes`,

  "Junk Docs Nashville": `## Strengths
* **5-star reviews praise the hoarding cleanup specialty** — compassionate, non-judgmental crews handle sensitive situations that other companies refuse or botch
* **Customers highlight downtown convenience** — central Nashville location means fast arrival times for the densest customer area
* **Reviews mention crews who are patient and respectful** — hoarding situations require emotional sensitivity, and this team delivers it consistently

## Weaknesses
* **1-star reviews cite chronic lateness** — arrival windows are missed frequently, with some customers reporting 2+ hour delays
* **Complaints about lack of online presence and reviews** — customers struggle to find information before booking, creating trust hesitation
* **Negative reviews mention inconsistent pricing** — different crew members quote different prices for similar jobs, suggesting no standardized rate card

## Opportunities
* Implement a **GPS-based ETA notification system** — text customers automatically when the truck is 30 minutes and 10 minutes away
* Create a **standardized pricing matrix** that all crew members use — eliminates inconsistency and builds customer trust in fair pricing
* Develop **hoarding-specific case studies and testimonials** on Google Business Profile — showcase the specialty that competitors avoid

## Threats
* Lateness complaints are the **#1 reputation risk** — punctuality is a solvable internal problem that's being allowed to damage the brand
* Without standardized pricing, **crews may be undercharging or overcharging** — both scenarios damage the business (lost margin or lost trust)
* Low review volume means **a single bad review has outsized impact** on the overall rating — no buffer against occasional negative experiences`,

  "Franklin Junk Solutions": `## Strengths
* **5-star reviews highlight the premium estate cleanout expertise** — crews handle antiques, large furniture, and sensitive items with care that matches Franklin's affluent expectations
* **Customers praise the detailed pre-job walkthrough** — the estimator photographs every room and creates a removal plan before the crew arrives
* **Reviews mention post-job follow-up emails** with donation receipts and disposal documentation — customers feel good about where their items went

## Weaknesses
* **1-star reviews cite slow availability** — 10-14 day wait times during peak seasons frustrate customers with urgent cleanout needs
* **Complaints about the premium pricing** — while justified by service quality, some customers feel the Franklin premium is excessive for basic junk removal
* **Negative reviews mention difficulty reaching the team by phone** — calls go to a scheduling service that can't answer detailed questions

## Opportunities
* Add a **second crew for peak season overflow** — even a part-time crew during spring/summer would cut wait times significantly
* Create **tiered service packages** (Basic Haul vs. Premium Estate Cleanout) so price-sensitive customers have an option that matches their needs
* Switch to a **direct-line phone system** during business hours with the scheduling service as after-hours backup only

## Threats
* Long wait times during peak season mean **customers book competitors while waiting** — lost revenue from the highest-demand period of the year
* Single-tier premium pricing creates a **vulnerability to value-focused competitors** entering the Williamson County market
* Over-dependence on the scheduling service for customer communication means **the team loses control of first impressions** and customer experience`,

  "Volunteer Junk Haul": `## Strengths
* **5-star reviews praise the consistent, no-drama service** — crews show up, do the work efficiently, and leave the space clean without needing hand-holding
* **Customers highlight the strong East Nashville neighborhood expertise** — crews know the tight streets, parking situations, and building access points
* **Reviews mention fair pricing for honest work** — no upsells, no surprises, just the quoted price for the job described

## Weaknesses
* **1-star reviews cite no same-day availability** — customers needing urgent removal are turned away and go to competitors who can respond immediately
* **Complaints about no online price transparency** — customers must call for every estimate, which feels like a friction point in the booking process
* **Negative reviews mention limited communication during job** — once booked, customers don't hear anything until the crew shows up, creating anxiety

## Opportunities
* Implement **SMS updates at key milestones** — booking confirmation, day-before reminder, morning-of ETA, and post-job follow-up
* Add a **pricing calculator on the website** with common item/volume estimates so customers can self-serve before calling
* Reserve **one daily slot for same-day emergency requests** at a slight premium — captures urgent business without disrupting the schedule

## Threats
* No proactive communication means **customers feel forgotten between booking and service** — this quiet period is when cancellations and competitor-switching happen
* East Nashville is **rapidly gentrifying with higher customer expectations** — the no-frills approach may not match the evolving neighborhood demographics
* Growing review count from competitors in the area is **diluting the local visibility advantage** that was previously a moat`,

  "Clean Sweep Junk Nashville": `## Strengths
* **5-star reviews consistently mention affordability** — customers feel they got significantly more value compared to franchise competitors
* **Reviews praise the flexible weekend scheduling** — Saturday and Sunday availability captures customers that weekday-only competitors miss
* **Customers note the friendly, approachable crew demeanor** — relaxed professionalism makes the experience comfortable for homeowners

## Weaknesses
* **1-star reviews cite inconsistent job quality** — some crews are thorough while others leave small debris or don't sweep after loading
* **Complaints about a worn-looking truck** — customers say the vehicle's appearance makes the business look less professional and trustworthy
* **Negative reviews mention no confirmation communications** — customers don't receive booking confirmations, reminders, or ETAs

## Opportunities
* Create a **post-job quality checklist** that every crew member must complete and photograph before leaving the site — standardizes the cleanup quality
* Invest in **truck branding and regular cleaning** — a clean, well-branded truck is a mobile billboard and builds instant customer confidence
* Set up **automated booking confirmation and reminder texts** — virtually free to implement and eliminates a major source of customer anxiety

## Threats
* Inconsistent quality means **good crews carry the burden of bad crews' mistakes** — without accountability, the best employees may leave
* Unprofessional truck appearance actively **undermines the affordability positioning** — customers associate worn equipment with poor service, not good value
* Without communication systems, **no-show situations create maximum customer frustration** — they have no way to check if their appointment is still happening`,

  "Hermitage Hauling Co": `## Strengths
* **5-star reviews glow about the owner's personal care** — every review mentions the owner by name, showing a level of personal connection competitors can't replicate
* **Customers highlight meticulous property protection** — the owner uses blankets on floors, tape on wall corners, and photographs any pre-existing damage before starting
* **Reviews praise the honest assessments** — the owner tells customers when they don't need full junk removal and suggests cheaper alternatives

## Weaknesses
* **1-star reviews cite extremely limited availability** — owner-only operation means 3-5 jobs per week maximum, with multi-week wait times
* **Complaints about no phone pickup during jobs** — when the owner is on a job, calls go unanswered for hours
* **Negative reviews mention inability to handle large commercial jobs** — single-person operation can't manage estate cleanouts or office clearings alone

## Opportunities
* Hire a **part-time assistant** to double job capacity while maintaining the owner's quality oversight on every job
* Set up a **simple voicemail-to-text service** that forwards calls to the owner's phone as texts — allows responses between jobs without phone interruptions
* Partner with **a local moving company for large jobs** — the owner provides the customer relationship and quality control while the partner provides labor

## Threats
* Owner-only model has reached **maximum capacity** — without scaling, the business can't grow and wait times will only increase
* Every unanswered call is a **customer who books a competitor instead** — lost leads from availability gaps are invisible but significant
* Mt. Juliet area is growing rapidly with **new service businesses entering the market** — the personal-touch advantage diminishes if customers can't get booked`,

  "Music City Junk Removal": `## Strengths
* **5-star reviews praise the energetic, fast-working crews** — customers note that jobs estimated at 2 hours are completed in 90 minutes without cutting corners
* **Customers highlight the memorable branded experience** — Music City-themed truck wraps, crew t-shirts, and a fun brand personality make the service feel premium
* **Reviews mention the easy online booking process** — website scheduling with instant confirmation and clear pricing ranges earns trust before the crew arrives

## Weaknesses
* **1-star reviews cite overworked crews making mistakes** — fast-paced job schedules mean occasional items removed that shouldn't be, or areas not fully cleaned
* **Complaints about difficulty getting refunds or corrections** — when issues arise, the resolution process is slow and requires multiple phone calls
* **Negative reviews mention inconsistency between crews** — some teams are outstanding while others feel rushed and detached

## Opportunities
* Implement a **"pause and confirm" checkpoint** mid-job where crews verify with the customer that the right items are being removed — prevents costly mistakes
* Create a **streamlined resolution process** with a single point of contact for complaints — resolve issues in one call instead of three
* Develop a **crew consistency program** that pairs experienced leads with newer members on a structured rotation to maintain quality standards

## Threats
* Rapid growth without matching quality controls means **mistake frequency will scale with volume** — more jobs = more errors without process improvements
* Slow complaint resolution actively **generates negative reviews** — frustrated customers who feel ignored write the most damaging reviews
* Brand personality can't compensate for **service quality gaps indefinitely** — eventually the "cool brand" reputation gives way to "unreliable" if mistakes continue`,
};

const FAKE_PHONES = [
  "(615) 555-0147", "(615) 555-0231", "(615) 555-0389", "(615) 555-0412",
  "(615) 555-0568", "(615) 555-0623", "(615) 555-0791", "(615) 555-0834",
  "(615) 555-0902", "(615) 555-0156", "(615) 555-0278", "(615) 555-0345",
  "(615) 555-0467", "(615) 555-0534", "(615) 555-0689", "(615) 555-0712",
  "(615) 555-0856", "(615) 555-0923",
];

// Keyword pool used to generate per-business SEO keyword data
const JUNK_REMOVAL_KEYWORDS = [
  { keyword: "junk removal nashville", searchVolume: 1600, keywordDifficulty: 38 },
  { keyword: "junk removal near me", searchVolume: 5400, keywordDifficulty: 62 },
  { keyword: "junk hauling nashville", searchVolume: 880, keywordDifficulty: 28 },
  { keyword: "same day junk removal nashville", searchVolume: 720, keywordDifficulty: 32 },
  { keyword: "furniture removal nashville", searchVolume: 590, keywordDifficulty: 22 },
  { keyword: "junk pickup nashville", searchVolume: 660, keywordDifficulty: 28 },
  { keyword: "appliance removal nashville", searchVolume: 480, keywordDifficulty: 20 },
  { keyword: "dumpster rental nashville", searchVolume: 1200, keywordDifficulty: 42 },
  { keyword: "cheap junk removal nashville", searchVolume: 540, keywordDifficulty: 30 },
  { keyword: "mattress disposal nashville", searchVolume: 430, keywordDifficulty: 22 },
  { keyword: "estate cleanout nashville", searchVolume: 320, keywordDifficulty: 18 },
  { keyword: "construction debris removal nashville", searchVolume: 280, keywordDifficulty: 20 },
  { keyword: "hoarding cleanup nashville", searchVolume: 210, keywordDifficulty: 15 },
  { keyword: "hot tub removal nashville", searchVolume: 170, keywordDifficulty: 12 },
  { keyword: "piano removal nashville", searchVolume: 110, keywordDifficulty: 8 },
  { keyword: "office furniture removal nashville", searchVolume: 260, keywordDifficulty: 20 },
  { keyword: "junk removal brentwood tn", searchVolume: 350, keywordDifficulty: 25 },
  { keyword: "tv recycling nashville", searchVolume: 190, keywordDifficulty: 14 },
  { keyword: "eco junk removal nashville", searchVolume: 120, keywordDifficulty: 10 },
  { keyword: "moving and junk removal nashville", searchVolume: 380, keywordDifficulty: 28 },
];

// Enrich each business with all fields the BusinessReviewModal expects
EXAMPLE_JUNK_REMOVAL_NASHVILLE.forEach((biz, idx) => {
  biz.types = [biz.primary_type];
  biz.phone = FAKE_PHONES[idx % FAKE_PHONES.length];
  biz.demo_image_url = DEMO_IMAGE_POOL[idx % DEMO_IMAGE_POOL.length];

  const slug = biz.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/, "");
  biz.website_uri = `https://www.${slug}.com`;

  biz.versus_insights = INTERNAL_SWOT_BY_BUSINESS[biz.name] || INTERNAL_SWOT_BY_BUSINESS["Junk King Nashville"];

  // Generate monthlyRatings from sentiment breakdown ratios
  const sb = biz.historicalData.sentimentBreakdown;
  const total = sb.positive + sb.neutral + sb.negative;
  const pRatio = total > 0 ? sb.positive / total : 0.7;
  const ngRatio = total > 0 ? sb.negative / total : 0.1;
  const counts = biz.historicalData.monthlyReviewCounts;
  const monthlyRatings = {};
  Object.entries(counts).forEach(([month, count]) => {
    const pos = Math.round(count * pRatio);
    const neg = Math.round(count * ngRatio);
    monthlyRatings[month] = { positive: pos, neutral: Math.max(0, count - pos - neg), negative: neg };
  });
  biz.historicalData.monthlyRatings = monthlyRatings;

  // Fake SpyFu data: domain stats, seo keywords, and ad history
  const visitors = biz.traffic_data?.metrics?.estimated_monthly_visitors || 500;
  const strength = Math.min(95, Math.round(30 + (visitors / 100)));
  // Higher-traffic businesses rank better and have more keywords
  const baseRank = visitors >= 5000 ? 2 : visitors >= 2000 ? 4 : visitors >= 800 ? 7 : 11;
  const keywordCount = Math.min(JUNK_REMOVAL_KEYWORDS.length, Math.max(4, Math.round(visitors / 350)));
  const bizKeywords = [];
  for (let ki = 0; ki < keywordCount; ki++) {
    const kwIdx = (idx * 4 + ki) % JUNK_REMOVAL_KEYWORDS.length;
    const kw = JUNK_REMOVAL_KEYWORDS[kwIdx];
    bizKeywords.push({ ...kw, rank: Math.max(1, baseRank + ki * 2) });
  }

  biz.spyfu_data = {
    domain: biz.website_uri.replace("https://www.", ""),
    domain_stats: {
      results: [{
        strength,
        monthlyOrganicClicks: visitors,
        monthlyOrganicValue: Math.round(visitors * 1.8),
        monthlyPaidClicks: Math.round(visitors * 0.3),
        monthlyBudget: Math.round(visitors * 0.5),
        totalOrganicResults: Math.round(visitors / 5),
        totalAdsPurchased: Math.round(visitors / 20),
        averageOrganicRank: parseFloat((baseRank + 3).toFixed(1)),
      }],
    },
    seo_keywords: {
      results: bizKeywords,
    },
    domain_ad_history: {
      results: FAKE_AD_TEMPLATES.map((ad, adIdx) => ({
        ...ad,
        url: biz.website_uri + (adIdx === 0 ? "" : adIdx === 1 ? "/pricing" : "/commercial"),
        position: ad.position + (idx % 3),
        searchDateId: ad.searchDateId - (idx * 2),
      })),
    },
  };
});

const EXAMPLE_YEAR_DATA = EXAMPLE_JUNK_REMOVAL_NASHVILLE.map((biz) => ({
  maps_uri: biz.maps_uri,
  name: biz.name,
  data: biz.historicalData,
  insight: biz.insight,
}));

// Tranched traffic-shape templates: each represents a believable real-world
// trajectory (step-up with a mid-year dip, plateau then breakout, etc.) rather
// than the smooth sinusoidal pattern that made charts look unnaturally even.
const TRAFFIC_VARIANTS = [
  // 0: ramp -> mid-year dip -> late surge (used by the agency hero demo biz)
  [0.62, 0.68, 0.71, 0.95, 1.05, 1.10, 0.78, 0.74, 0.88, 1.18, 1.28, 1.42],
  // 1: steady base with two distinct surges
  [0.55, 0.58, 0.92, 0.88, 0.95, 1.05, 1.02, 1.30, 1.12, 1.06, 1.20, 1.15],
  // 2: volatile with sharp jumps between tranches
  [0.85, 0.62, 0.70, 1.10, 0.82, 1.18, 0.95, 0.78, 1.25, 0.92, 1.05, 1.35],
  // 3: long plateau followed by a breakout
  [0.78, 0.80, 0.82, 0.81, 0.79, 1.18, 1.22, 1.25, 1.05, 1.30, 1.45, 1.38],
  // 4: high open, sustained drawdown, partial recovery
  [1.25, 1.18, 1.20, 0.95, 0.72, 0.68, 0.70, 0.74, 0.90, 0.95, 1.05, 1.12],
];

// Cheap deterministic hash so two charts for the same business stay consistent
// across renders without pulling in an extra dependency.
function hashSeed(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function trafficNoise(name, i) {
  const h = hashSeed(`${name}:${i}`);
  return ((h % 10000) / 10000 - 0.5) * 0.08;
}

function buildTrafficSeries(biz, idx, monthFormat) {
  const months = Object.keys(biz.historicalData.monthlyReviewCounts).sort();
  const baseTraffic = biz.traffic_data?.metrics?.estimated_monthly_visitors || 500;
  const variant = TRAFFIC_VARIANTS[idx % TRAFFIC_VARIANTS.length];
  return months.map((month, i) => {
    const level = variant[Math.min(i, variant.length - 1)];
    const value = Math.max(1, Math.round(baseTraffic * (level + trafficNoise(biz.name, i))));
    return {
      month: new Date(`${month}-01`).toLocaleDateString("en-US", { month: "short", year: monthFormat }),
      organicClicks: value,
    };
  });
}

const EXAMPLE_TRAFFIC_HISTORY = {};
EXAMPLE_JUNK_REMOVAL_NASHVILLE.forEach((biz, idx) => {
  EXAMPLE_TRAFFIC_HISTORY[biz.maps_uri] = buildTrafficSeries(biz, idx, "2-digit");
});

// Pre-computed sorted ranking arrays for the BusinessReviewModal
const getTrafficValue = (b) => b.traffic_data?.metrics?.estimated_monthly_visitors || 0;

const EXAMPLE_SORTED_BY_TOTAL = [...EXAMPLE_JUNK_REMOVAL_NASHVILLE]
  .sort((a, b) => (b.rating_count || 0) - (a.rating_count || 0));

const EXAMPLE_SORTED_BY_SENTIMENT = EXAMPLE_JUNK_REMOVAL_NASHVILLE.map((business) => {
  const sb = business.historicalData?.sentimentBreakdown || { positive: 0, neutral: 0, negative: 0 };
  const total = sb.positive + sb.neutral + sb.negative;
  const sentimentScore = total > 0 ? ((sb.positive + sb.neutral * 0.5) / total) * 100 : 0;
  return { ...business, sentimentScore, ...sb, total };
}).sort((a, b) => b.sentimentScore - a.sentimentScore);

const EXAMPLE_SORTED_BY_GROWTH = EXAMPLE_JUNK_REMOVAL_NASHVILLE.map((business) => {
  const monthlyData = business.historicalData?.monthlyReviewCounts || {};
  const months = Object.keys(monthlyData).sort();
  const totalGrowth = months.reduce((sum, month) => sum + (monthlyData[month] || 0), 0);
  const lastThreeMonths = months.length >= 3 ? months.slice(-3) : months;
  const threeMonthGrowth = lastThreeMonths.reduce((sum, month) => sum + (monthlyData[month] || 0), 0);
  return { ...business, threeMonthGrowth, totalGrowth };
}).sort((a, b) => b.totalGrowth - a.totalGrowth);

const EXAMPLE_SORTED_BY_TRAFFIC = [...EXAMPLE_JUNK_REMOVAL_NASHVILLE]
  .map((b) => ({ ...b, trafficValue: getTrafficValue(b) }))
  .filter((b) => b.trafficValue > 0)
  .sort((a, b) => b.trafficValue - a.trafficValue);

const EXAMPLE_SORTED_BY_SEO = [...EXAMPLE_JUNK_REMOVAL_NASHVILLE]
  .map((b) => {
    const traffic = getTrafficValue(b);
    const reviews = b.rating_count || 0;
    const rating = b.rating_avg || 0;
    const seoScore = (traffic > 0 ? Math.log10(traffic) * 15 : 0) + (reviews > 0 ? Math.log10(reviews) * 10 : 0) + rating * 5;
    return { ...b, seoScore };
  })
  .filter((b) => b.seoScore > 0)
  .sort((a, b) => b.seoScore - a.seoScore);

// Fake traffic history in the format BusinessReviewModal uses internally (month as "Mon YYYY")
const EXAMPLE_MODAL_TRAFFIC_HISTORY = {};
EXAMPLE_JUNK_REMOVAL_NASHVILLE.forEach((biz, idx) => {
  EXAMPLE_MODAL_TRAFFIC_HISTORY[biz.maps_uri] = buildTrafficSeries(biz, idx, "numeric");
});

// Fake pricing perception data for the modal
function buildDemoPricing(biz) {
  const visitors = biz.traffic_data?.metrics?.estimated_monthly_visitors || 500;
  const tier = visitors > 3000 ? 3 : visitors > 1000 ? 2 : 1;
  return {
    price_level: tier,
    price_label: tier === 1 ? "$" : tier === 2 ? "$$" : "$$$",
    perception_label: tier === 1 ? "Value Leader" : tier === 2 ? "Mid-Range" : "Premium Positioning",
    perception_score: 2.0 + tier * 0.8,
    classification: tier <= 2 ? "Value Advantage" : "Premium Perception",
    market_rank: {
      rank: Math.max(1, Math.round(18 * (1 - visitors / 9000))),
      total: 18,
    },
    top_positive_keywords: [
      { keyword: "affordable", count: 8 },
      { keyword: "fair price", count: 5 },
      { keyword: "good value", count: 4 },
      { keyword: "reasonable", count: 3 },
    ],
    top_negative_keywords: [
      { keyword: "expensive", count: 2 },
      { keyword: "pricey", count: 1 },
    ],
    mentions: [
      {
        context: "Great service at an affordable price. They were much cheaper than the other companies I called.",
        keyword: "affordable",
        stars: 5,
        reviewer_name: "Sarah M.",
        effective_sentiment: "cheap",
      },
      {
        context: "Fair price for the amount of junk they hauled away. Would definitely recommend to anyone looking for good value.",
        keyword: "fair price, good value",
        stars: 5,
        reviewer_name: "Mike T.",
        effective_sentiment: "cheap",
      },
      {
        context: "A bit pricey compared to some competitors but the quality of service made up for it.",
        keyword: "pricey",
        stars: 4,
        reviewer_name: "Jason R.",
        effective_sentiment: "expensive",
      },
    ],
  };
}

// ---------------------------------------------------------------------------
// Agency hero "story slide" data
// ---------------------------------------------------------------------------
// The agency landing hero rotates through two slides that both reuse the
// BusinessReviewModal but with intentionally different storytelling data:
//
//   1. "Where They Are"        — weak rankings (Growth 13th, Reviews 15th,
//                                Traffic 8th, Sentiment 19th, SEO 10th).
//   2. "Where You'll Take Them" — same module, dramatically better numbers
//                                so the prospect sees the transformation.
//
// Each slide returns a self-contained bundle of props ready to hand to
// BusinessReviewModal. The data is fully derived from EXAMPLE_JUNK_REMOVAL_NASHVILLE
// so there is no risk of drift between what the modal expects and what the
// example exposes.
//
// Implementation notes:
//   * BusinessReviewModal computes each rank via
//     `sortedBy*?.findIndex(b => b.maps_uri === business.maps_uri) + 1`.
//     We can therefore force any rank by removing the target from the
//     base sorted array and splicing it back in at index (rank - 1).
//   * To make rank 19th meaningful we need at least 19 entries in the
//     sentiment array, so we synthesize one extra "filler" competitor that
//     only exists inside the agency hero data set.
//   * The displayed metric values on the rank cards come from the entry
//     we insert (e.g. `trafficValue`, `sentimentScore`), so we attach
//     matching enrichment fields per array.

// One extra competitor used purely to extend the demo competitor set from
// 18 → 19, so the agency hero can show a believable 19th-place ranking.
const AGENCY_HERO_FILLER = (() => {
  const biz = {
    name: 'Cumberland Junk & Haul',
    address: '512 Lebanon Pike, Nashville, TN 37210',
    latitude: 36.1721,
    longitude: -86.7339,
    maps_uri: 'https://maps.google.com/?cid=cumberland-junk-hero',
    rating_count: 64,
    rating_avg: 4.2,
    primary_type: 'junk_removal_service',
    traffic_data: { metrics: { estimated_monthly_visitors: 240 } },
    historicalData: {
      monthlyReviewCounts: {
        '2025-04': 1, '2025-05': 2, '2025-06': 3, '2025-07': 2,
        '2025-08': 4, '2025-09': 3, '2025-10': 4, '2025-11': 3,
        '2025-12': 1, '2026-01': 2, '2026-02': 4, '2026-03': 2,
      },
      sentimentBreakdown: { positive: 50, neutral: 9, negative: 5 },
    },
    insight:
      '## Competitive Advantages\n* **Lean local operator** with low overhead in East Nashville.\n## Quick Wins\n* **Tiny review footprint** — basic Google Business Profile work would unlock visibility quickly.',
  };

  biz.types = [biz.primary_type];
  biz.phone = '(615) 555-0719';
  biz.demo_image_url = DEMO_IMAGE_POOL[0];
  const slug = biz.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '');
  biz.website_uri = `https://www.${slug}.com`;
  biz.versus_insights = INTERNAL_SWOT_BY_BUSINESS['Junk Docs Nashville'];

  const sb = biz.historicalData.sentimentBreakdown;
  const total = sb.positive + sb.neutral + sb.negative;
  const pRatio = total > 0 ? sb.positive / total : 0.7;
  const ngRatio = total > 0 ? sb.negative / total : 0.1;
  const counts = biz.historicalData.monthlyReviewCounts;
  const monthlyRatings = {};
  Object.entries(counts).forEach(([month, count]) => {
    const pos = Math.round(count * pRatio);
    const neg = Math.round(count * ngRatio);
    monthlyRatings[month] = {
      positive: pos,
      neutral: Math.max(0, count - pos - neg),
      negative: neg,
    };
  });
  biz.historicalData.monthlyRatings = monthlyRatings;

  const visitors = biz.traffic_data.metrics.estimated_monthly_visitors;
  biz.spyfu_data = {
    domain: biz.website_uri.replace('https://www.', ''),
    domain_stats: {
      results: [{
        strength: Math.min(95, Math.round(30 + visitors / 100)),
        monthlyOrganicClicks: visitors,
        monthlyOrganicValue: Math.round(visitors * 1.8),
        monthlyPaidClicks: Math.round(visitors * 0.3),
        monthlyBudget: Math.round(visitors * 0.5),
        totalOrganicResults: Math.round(visitors / 5),
        totalAdsPurchased: Math.round(visitors / 20),
        averageOrganicRank: 14,
      }],
    },
    seo_keywords: { results: [] },
    domain_ad_history: { results: [] },
  };

  return biz;
})();

// Pre-computed sorted-array enrichments for the filler so we can splice it
// into the per-slide arrays without re-implementing the existing math.
const FILLER_ENRICHED = (() => {
  const biz = AGENCY_HERO_FILLER;
  const monthlyData = biz.historicalData.monthlyReviewCounts;
  const months = Object.keys(monthlyData).sort();
  const totalGrowth = months.reduce((sum, m) => sum + (monthlyData[m] || 0), 0);
  const last3 = months.length >= 3 ? months.slice(-3) : months;
  const threeMonthGrowth = last3.reduce((sum, m) => sum + (monthlyData[m] || 0), 0);

  const sb = biz.historicalData.sentimentBreakdown;
  const sentimentTotal = sb.positive + sb.neutral + sb.negative;
  const sentimentScore =
    sentimentTotal > 0 ? ((sb.positive + sb.neutral * 0.5) / sentimentTotal) * 100 : 0;

  const visitors = getTrafficValue(biz);
  const reviews = biz.rating_count || 0;
  const rating = biz.rating_avg || 0;
  const seoScore =
    (visitors > 0 ? Math.log10(visitors) * 15 : 0) +
    (reviews > 0 ? Math.log10(reviews) * 10 : 0) +
    rating * 5;

  return {
    forTotal: { ...biz },
    forGrowth: { ...biz, threeMonthGrowth, totalGrowth },
    forSentiment: { ...biz, sentimentScore, ...sb, total: sentimentTotal },
    forTraffic: { ...biz, trafficValue: visitors },
    forSeo: { ...biz, seoScore },
  };
})();

// Build a per-slide enriched target entry (Junk King with overridden metrics).
function buildAgencyHeroTarget(variant) {
  const isWeak = variant === 'weak';
  const base = EXAMPLE_JUNK_REMOVAL_NASHVILLE[0];

  // Storytelling metric overrides
  const overrides = isWeak
    ? {
        rating_count: 122,
        rating_avg: 4.1,
        traffic_visitors: 1550,
        sentiment: { positive: 92, neutral: 28, negative: 22 },
        monthlyReviewCounts: {
          '2025-04': 6, '2025-05': 7, '2025-06': 6, '2025-07': 8,
          '2025-08': 7, '2025-09': 6, '2025-10': 5, '2025-11': 4,
          '2025-12': 3, '2026-01': 9, '2026-02': 6, '2026-03': 4,
        },
      }
    : {
        rating_count: 1187,
        rating_avg: 4.9,
        traffic_visitors: 11800,
        sentiment: { positive: 1075, neutral: 92, negative: 20 },
        monthlyReviewCounts: {
          '2025-04': 38, '2025-05': 45, '2025-06': 52, '2025-07': 61,
          '2025-08': 72, '2025-09': 84, '2025-10': 96, '2025-11': 108,
          '2025-12': 124, '2026-01': 141, '2026-02': 158, '2026-03': 178,
        },
      };

  const target = {
    ...base,
    rating_count: overrides.rating_count,
    rating_avg: overrides.rating_avg,
    traffic_data: {
      metrics: { estimated_monthly_visitors: overrides.traffic_visitors },
    },
    historicalData: {
      monthlyReviewCounts: { ...overrides.monthlyReviewCounts },
      sentimentBreakdown: { ...overrides.sentiment },
    },
  };

  // Re-derive monthlyRatings using the same logic as the base enrichment loop
  // so the modal's review-volume charts stay believable for the new numbers.
  const sb = target.historicalData.sentimentBreakdown;
  const sentTotal = sb.positive + sb.neutral + sb.negative;
  const pRatio = sentTotal > 0 ? sb.positive / sentTotal : 0.7;
  const ngRatio = sentTotal > 0 ? sb.negative / sentTotal : 0.1;
  const counts = target.historicalData.monthlyReviewCounts;
  const monthlyRatings = {};
  Object.entries(counts).forEach(([month, count]) => {
    const pos = Math.round(count * pRatio);
    const neg = Math.round(count * ngRatio);
    monthlyRatings[month] = {
      positive: pos,
      neutral: Math.max(0, count - pos - neg),
      negative: neg,
    };
  });
  target.historicalData.monthlyRatings = monthlyRatings;

  // Update spyfu_data so the Web Traffic + SEO sections show numbers that
  // match the overridden traffic volume instead of the base 3,200 visitors.
  const visitors = overrides.traffic_visitors;
  target.spyfu_data = {
    ...base.spyfu_data,
    domain_stats: {
      results: [{
        ...(base.spyfu_data?.domain_stats?.results?.[0] || {}),
        strength: Math.min(95, Math.round(30 + visitors / 100)),
        monthlyOrganicClicks: visitors,
        monthlyOrganicValue: Math.round(visitors * 1.8),
        monthlyPaidClicks: Math.round(visitors * 0.3),
        monthlyBudget: Math.round(visitors * 0.5),
        totalOrganicResults: Math.round(visitors / 5),
        totalAdsPurchased: Math.round(visitors / 20),
        averageOrganicRank: isWeak ? 11 : 3,
      }],
    },
  };

  // Build matching enriched copies for each sorted array
  const months = Object.keys(target.historicalData.monthlyReviewCounts).sort();
  const totalGrowth = months.reduce(
    (sum, m) => sum + (target.historicalData.monthlyReviewCounts[m] || 0),
    0,
  );
  const last3 = months.length >= 3 ? months.slice(-3) : months;
  const threeMonthGrowth = last3.reduce(
    (sum, m) => sum + (target.historicalData.monthlyReviewCounts[m] || 0),
    0,
  );

  const sentimentScore =
    sentTotal > 0 ? ((sb.positive + sb.neutral * 0.5) / sentTotal) * 100 : 0;

  const seoScore =
    (visitors > 0 ? Math.log10(visitors) * 15 : 0) +
    (target.rating_count > 0 ? Math.log10(target.rating_count) * 10 : 0) +
    (target.rating_avg || 0) * 5;

  return {
    target,
    enriched: {
      forTotal: { ...target },
      forGrowth: { ...target, threeMonthGrowth, totalGrowth },
      forSentiment: { ...target, sentimentScore, ...sb, total: sentTotal },
      forTraffic: { ...target, trafficValue: visitors },
      forSeo: { ...target, seoScore },
    },
  };
}

// Build a traffic series that visually matches the story arc of the slide.
function buildAgencyHeroTrafficSeries(target, variant) {
  const months = Object.keys(target.historicalData.monthlyReviewCounts).sort();
  const baseTraffic = getTrafficValue(target) || 1000;
  // Weak: traffic slides 25% over the year. Strong: steady climb to +60%.
  const weakCurve = [1.08, 1.05, 1.02, 0.98, 0.94, 0.90, 0.86, 0.82, 0.78, 0.76, 0.74, 0.72];
  const strongCurve = [0.62, 0.66, 0.71, 0.76, 0.82, 0.88, 0.94, 1.02, 1.12, 1.24, 1.38, 1.52];
  const curve = variant === 'weak' ? weakCurve : strongCurve;
  return months.map((month, i) => {
    const level = curve[Math.min(i, curve.length - 1)];
    const noise = trafficNoise(target.name + variant, i);
    const value = Math.max(1, Math.round(baseTraffic * (level + noise)));
    return {
      month: new Date(`${month}-01`).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
      }),
      organicClicks: value,
    };
  });
}

function buildAgencyHeroSlide(variant) {
  const ranks = variant === 'weak'
    ? { growth: 13, totalReviews: 15, traffic: 8, sentiment: 19, seo: 10 }
    : { growth: 2, totalReviews: 1, traffic: 3, sentiment: 1, seo: 2 };

  const { target, enriched } = buildAgencyHeroTarget(variant);
  const targetUri = target.maps_uri;

  const stripTarget = (arr) => arr.filter((b) => b.maps_uri !== targetUri);

  // Ensure 19 entries total so a 19th-place ranking is meaningful.
  const insertAt = (arr, filler, item, rank) => {
    const stripped = stripTarget(arr);
    // arr already has 18 entries (no filler), inserting filler then target
    // gives us 19. We push filler to the end so it occupies the bottom slot
    // by default; rank computation only depends on where `target` lands.
    const withFiller = [...stripped, filler];
    const idx = Math.max(0, Math.min(withFiller.length, rank - 1));
    const copy = [...withFiller];
    copy.splice(idx, 0, item);
    return copy;
  };

  const sortedByTotal = insertAt(
    EXAMPLE_SORTED_BY_TOTAL,
    FILLER_ENRICHED.forTotal,
    enriched.forTotal,
    ranks.totalReviews,
  );
  const sortedByGrowth = insertAt(
    EXAMPLE_SORTED_BY_GROWTH,
    FILLER_ENRICHED.forGrowth,
    enriched.forGrowth,
    ranks.growth,
  );
  const sortedBySentiment = insertAt(
    EXAMPLE_SORTED_BY_SENTIMENT,
    FILLER_ENRICHED.forSentiment,
    enriched.forSentiment,
    ranks.sentiment,
  );
  const sortedByTraffic = insertAt(
    EXAMPLE_SORTED_BY_TRAFFIC,
    FILLER_ENRICHED.forTraffic,
    enriched.forTraffic,
    ranks.traffic,
  );
  const sortedBySeo = insertAt(
    EXAMPLE_SORTED_BY_SEO,
    FILLER_ENRICHED.forSeo,
    enriched.forSeo,
    ranks.seo,
  );

  const yearData = [
    {
      maps_uri: target.maps_uri,
      name: target.name,
      data: target.historicalData,
      insight: target.insight,
    },
    ...EXAMPLE_YEAR_DATA.filter((d) => d.maps_uri !== targetUri),
    {
      maps_uri: AGENCY_HERO_FILLER.maps_uri,
      name: AGENCY_HERO_FILLER.name,
      data: AGENCY_HERO_FILLER.historicalData,
      insight: AGENCY_HERO_FILLER.insight,
    },
  ];

  const trafficHistory = {
    ...EXAMPLE_MODAL_TRAFFIC_HISTORY,
    [target.maps_uri]: buildAgencyHeroTrafficSeries(target, variant),
  };

  return {
    business: target,
    yearData,
    sortedByTotal,
    sortedByGrowth,
    sortedBySentiment,
    sortedByTraffic,
    sortedBySeo,
    trafficHistory,
    pricingData: buildDemoPricing,
    ranks,
  };
}

const EXAMPLE_DEMO_IMAGES = Object.fromEntries(
  [
    ...EXAMPLE_JUNK_REMOVAL_NASHVILLE,
    AGENCY_HERO_FILLER,
  ].map((biz) => [biz.maps_uri, biz.demo_image_url])
);

export {
  EXAMPLE_JUNK_REMOVAL_NASHVILLE,
  EXAMPLE_DEMO_IMAGES,
  EXAMPLE_YEAR_DATA,
  EXAMPLE_TRAFFIC_HISTORY,
  EXAMPLE_MODAL_TRAFFIC_HISTORY,
  EXAMPLE_SORTED_BY_TOTAL,
  EXAMPLE_SORTED_BY_SENTIMENT,
  EXAMPLE_SORTED_BY_GROWTH,
  EXAMPLE_SORTED_BY_TRAFFIC,
  EXAMPLE_SORTED_BY_SEO,
  buildDemoPricing,
  buildAgencyHeroSlide,
};
